import { render, staticRenderFns } from "./ChangeCollectionMass.vue?vue&type=template&id=01fd59c7&"
import script from "./ChangeCollectionMass.vue?vue&type=script&lang=js&"
export * from "./ChangeCollectionMass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports